import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export default function (ComposedComponent) {
  class RequireManageUsers extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    redirect(to) {
      global.window && window.location && window.location.replace(to + window.location.search);
    }

    render() {
      if (this.props.isLoading) {
        return <div></div>;
      }

      if (!this.props.user.permissions || !this.props.user.permissions.manageUsers) {
        this.redirect('/');
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      user: state.auth.user,
      isLoading: state.auth.isLoading,
    };
  }

  return connect(mapStateToProps)(RequireManageUsers);
}
